import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=480488e8&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"
import style0 from "./LinkButton.scss?vue&type=style&index=0&id=480488e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480488e8",
  null
  
)

export default component.exports